import axios from 'axios';
import api from './api';

export interface QrLandingTemplate {
  html: string;
  isActive: boolean;
  updatedAt: string | null;
  updatedBy: string | null;
}

export interface QrLandingTemplatePayload {
  html: string;
  isActive: boolean;
}

const base = (venueId: string) => `/admin/venue/${venueId}/qr-landing-template`;

/** Turn a backend validation/save error into a readable message. */
export function extractQrTemplateError(err: unknown): string {
  if (axios.isAxiosError(err)) {
    const data = err.response?.data as Record<string, unknown> | undefined;
    const errorObj = data?.['error'] as Record<string, unknown> | undefined;
    const message = errorObj?.['message'] ?? data?.['message'];
    if (typeof message === 'string' && message) return message;
    if (err.response?.status === 403) return 'You do not have permission to edit this template.';
  }
  if (err instanceof Error && err.message) return err.message;
  return 'An unexpected error occurred. Please try again.';
}

const qrLandingTemplateService = {
  get(venueId: string): Promise<QrLandingTemplate> {
    return api.get<QrLandingTemplate>(base(venueId)).then(r => r.data);
  },
  save(venueId: string, payload: QrLandingTemplatePayload): Promise<QrLandingTemplate> {
    return api.put<QrLandingTemplate>(base(venueId), payload).then(r => r.data);
  },
};

export default qrLandingTemplateService;
